import { render, staticRenderFns } from "./tree-table.vue?vue&type=template&id=0baca9c2&scoped=true&"
import script from "./tree-table.vue?vue&type=script&lang=js&"
export * from "./tree-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baca9c2",
  null
  
)

export default component.exports